import {
  qs,
  qsa,
  contains,
  listen,
  toggle,
  add,
  remove,
} from "@fluorescent/dom";

export default function (node) {
  const main = qs('[data-part="login"]', node);
  const reset = qs('[data-part="reset"]', node);
  const toggles = qsa("[data-toggle]", node);
  const loginError = qs(".form-status__message--error", reset);

  const isSuccess = qs(".form-status__message--success", reset);
  const successMessage = qs("[data-success-message]", node);

  if (isSuccess) {
    add(successMessage, "visible");
    add(reset, "hide");
  }

  if (loginError) {
    add(main, "hide");
    remove(reset, "hide");

    main.setAttribute("aria-hidden", true);
    reset.setAttribute("aria-hidden", false);
  }

  function toggleView(e) {
    e && e.preventDefault();
    toggle([main, reset], "hide");

    main.setAttribute("aria-hidden", contains(main, "hide"));
    reset.setAttribute("aria-hidden", contains(reset, "hide"));
  }

  const events = [listen(toggles, "click", toggleView)];

  const unload = () => {
    events.forEach(unsubscribe => unsubscribe());
  };

  return {
    unload,
  };
}
